export var varArrowColor = 'var(--_3ujfig0)';